export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/avlLogo.png" alt="About Me" height={970} width={794} />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title"></p>
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
            As a junior at PES Modern College of Engineering, I am dedicated to
            leveraging technology for innovative solutions. Immersed in
            blockchain development, web-development, stock market analysis, and
            dropshipping.
          </p>
          <p className="hero--section-description">
            I possess a strong programming foundation in Java, C++, Solidity,
            JavaScript, HTML, CSS, Linux, React.js, Node.js, expressjs, and
            mongodb. Proficient in Git and GitHub, I excel in collaborative
            coding environments, valuing version control for high-quality
            software production.
          </p>
        </div>
      </div>
    </section>
  );
}
